<template>
  <div class="wallet-container">
    <loader ref="loader" />
    <template v-if="method === QRCODE">
    <crypto-wallet
      :isContinuedTransaction="isContinuedTransaction"
      :isPreview="isPreview"
      :walletOptions="walletOptions"
      :selectedTab="selectedTab === cryptoWalletName"
      @setLoader="setLoader"
      @paymentConfirmed="isPaymentMethodVisible = false"
      :navigateToPreviousStep="navigateToPreviousStep"
      :cartData="cartData"
      @cryptoPaymentStatus="setCryptoPaymentStatus"
      @anyWalletCoin="onWalletCoinChange"
      @changePaymentType="changePaymentType"
    />
    </template>
    <template v-else-if="method === WALLET">
      <wallet-connect
        :cartData="cartData"
        @onConnectionChange="onConnectionChange"
        @changePaymentType="changePaymentType"
        @setInprocess="setInprocess"
      />
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "../utils/wagmi.config";
import { GET_SETTINGS, GET_USER_INFO, USER_TRACK_EVENTS } from "@/store/modules/user/consts";
import {
  CONTINUED_TRANSACTION,
  PAYMENT_CONTINUED,
} from "@/utils/event.constants";

export default {
  name: "WalletPage",
  components: {},
  props: {
    isPreview: Boolean,
    selectedTab: Boolean,
    isContinuedTransaction: Boolean,
    navigateToPreviousStep: {
      default: false,
      type: Boolean,
    },
    walletOptions: Array,
    setLoader: Function,
    paymentConfirmed: Function,
    cartData: Object,
    cryptoPaymentStatus: Function,
    anyWalletCoin: Function,
  },
  data() {
    return {
      WALLET: "WALLET",
      QRCODE: "QRCODE",
      method: "WALLET",
      connected: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs?.loader?.hide();
      this.$store.dispatch(`user/${GET_SETTINGS}`);
      this.$store.dispatch(`user/${GET_USER_INFO}`);
      window.EventBus.on(PAYMENT_CONTINUED, (data) => {
        this.$refs?.loader?.start();
        if (!data?.walletPayment) this.method = this.QRCODE;
        setTimeout(() => {
          window.EventBus.emit(CONTINUED_TRANSACTION, data);
          this.$refs?.loader?.hide();
        }, 1000);
      });
    });
  },
  compute: {
    ...mapGetters({
      isGuestUser: "auth/isGuestUser",
      cart: "user/cart",
      settings: "user/settings",
      displayCurrency: "user/displayCurrency",
      currencies: "user/currencies",
      marketInfo: "user/marketInfo",
      userInfo: "user/userInfo",
      socket: "user/getSocketResponse",
      paymentCompleted: "auth/paymentCompleted",
      cryptoWalletStep: "user/getCryptoWalletStep",
    }),
  },
  methods: {
    onConnectionChange(val) {
      this.connected = val;
    },
    setInprocess(val) {
      this.$emit("setInprocess", val);
    },
    alterOptions() {
      if (this.method === this.QRCODE) {
        this.method = this.WALLET;
      } else {
        this.method = this.QRCODE;
      }
    },
    changePaymentType(type) {
      this.method = type;
    },
    setCryptoPaymentStatus(status) {
      this.$emit('cryptoPaymentStatus', status);
    }
  },
};
</script>

<style lang="scss">
.wallet-container {
  background: #ffffff;
  padding-top: 15px;
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
  }
  &__subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }
  &__qroption {
    margin-top: 20px;
  }
  &__alter-option {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 16px 24px;
    box-shadow: 0px 2px 8px 0px #5757f51a;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
  }
  &__alter_icon {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
}
</style>
